import React, { FC } from 'react';
import { createStaticRanges, DateRangePicker } from 'react-date-range';
import { colors } from '../../../../theme/colors';
import './css/styles.css';
import './css/default.css';
import { staticRanges } from './default/defaultRanges';
import { EmptyRangeCalendarStyled } from './styled';

const languageConfiguration = require('react-date-range/dist/locale');

interface StaticRange {
    label: string
    range: () => { startDate: Date, endDate: Date }
}

interface DateRangeSelectProps {
    dateRange?: any;
    handleChangeDateRangeScope: (dateRange : any) => void;
    maxDate?: Date;
    minDate?: Date;
    customStaticRanges?: Array<StaticRange>;
}

const DateRangeSelect: FC<DateRangeSelectProps> = ({ dateRange, handleChangeDateRangeScope, maxDate, minDate, customStaticRanges }) => (
    <EmptyRangeCalendarStyled $isEmpty={!dateRange?.selection?.startDate || !dateRange?.selection?.endDate}>
        <DateRangePicker
            direction="vertical"
            inputRanges={[]}
            locale={languageConfiguration.fr}
            maxDate={maxDate}
            minDate={minDate}
            months={1}
            onChange={(item) => handleChangeDateRangeScope({ ...dateRange, ...item })}
            rangeColors={[colors.dateRangeDefault]}
            ranges={[dateRange.selection]}
            renderStaticRangeLabel={() => (null)}
            scroll={{ enabled: false }}
            showDateDisplay={false}
            staticRanges={createStaticRanges(customStaticRanges ?? staticRanges)}
        />
    </EmptyRangeCalendarStyled>
);

export default DateRangeSelect;
